module.exports = __webpack_public_path__ + "img/car-red.a24241d5.svg";